import React from "react";
import { Box, Paper, Typography, Button, Fade } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import logo from "./logo.png";

const accent = "#7209d4";

const ExpiredPage = () => (
  <Box
    sx={{
      minHeight: "100vh",
      background: accent,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Paper
      sx={{
        width: 1000,
        minHeight: 520,
        borderRadius: 4,
        overflow: "hidden",
        display: "flex",
        boxShadow: "0 8px 40px #0001",
      }}
    >
      {/* LEFT: Expired message */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: 4,
          background: "#fff",
        }}
      >
        <Typography
          sx={{
            color: accent,
            fontWeight: 700,
            letterSpacing: 2,
            fontSize: 22,
            mb: 5,
            mt: 2,
          }}
        >
          Readabled
        </Typography>
        <Fade in>
          <Box textAlign="center" pt={6}>
            <ErrorOutlineIcon sx={{ color: "#FF5252", fontSize: 54, mb: 2 }} />
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, my: 2, color: "#E53E3E" }}
            >
              Link Expired or Invalid
            </Typography>
            <Typography
              sx={{
                color: "#5B6274",
                fontWeight: 500,
                mb: 1,
                fontSize: 18,
              }}
            >
              The magic link is invalid or has expired.
              <br />
              Please request a new sign-in link.
            </Typography>
            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{
                background: accent,
                fontWeight: 700,
                borderRadius: 2.5,
                textTransform: "none",
                fontSize: 18,
                py: 1.4,
                boxShadow: "none",
                mt: 4,
                mb: 2,
                "&:hover": { background: "#6c1ecb" },
              }}
              onClick={() => (window.location.href = "/auth")}
            >
              Go to Login
            </Button>
          </Box>
        </Fade>
      </Box>
      {/* RIGHT: Illustration */}
      <Box
        sx={{
          flex: 1,
          background: "#EBEAFE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderLeft: "4px solid #fff",
          borderRadius: "0 12px 12px 0",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <img
          src={logo}
          alt="Magic R and owl"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
    </Paper>
  </Box>
);

export default ExpiredPage;
